import * as React from "react"

const Arrow = ({ color }) => {
    if(color === '#000') {
       var classes = 'arrow dark inline-block mr-4 transition-all duration-300'
    } else {
       var classes = 'arrow inline-block mr-4 transition-all duration-300'
    }
    return (
        <svg className={classes} xmlns="http://www.w3.org/2000/svg" width="150" height="24.543" viewBox="0 0 199.634 24.543">
            <g id="Pfeil" transform="translate(-0.295)">
                <path className="stroke-10" data-name="Stroke 10" d="M.3.781,196.676.375" transform="translate(0 11.895)" fill="none" stroke={color} strokeMiterlimit="10" strokeWidth="3"/>
                <path className="fill-12" d="M2.047,24.543,0,22.344,10.838,12.273,0,2.2,2.047,0l13.2,12.273Z" transform="translate(184.686)" fill={color}/>
            </g>
        </svg>
    )
}

export default Arrow
